import templateStr from 'text!./templates/pa-view-coverages.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwPcPaViewCoverages'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/pa/directives/PAViewCoverages.js
// module id = 1195
// module chunks = 0